import api from "@/libs/axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    supportPagesContent: { assistObjects: [] },
    loading: false,
    working: false,
  },
  getters: {
    supportPagesContent(state) {
      return state.supportPagesContent;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setStatistics(state, payload) {
      state.statistics = payload;
    },
    setSupportPagesContent(state, payload) {
      state.supportPagesContent = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async getSupportPagesContent({ commit }) {
      commit("setLoading", true);
      try {
        const data = await api.get(ep.SUPPORT).then((res) => res.data.data);
        if (data === null)
          commit("setSupportPagesContent", { assistObjects: [] });
        else commit("setSupportPagesContent", data);
      } catch (err) {
        console.error(err);
      } finally {
        commit("setLoading", false);
      }
    },

    async updateSupportPagesContent({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.put(ep.SUPPORT_BY_ID(payload.id), payload.form);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async updateSupportPagesObject({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.put(ep.SUPPORT_OBJECT_BY_ID(payload.id), payload);

        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async createSupportPagesObject({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.post(ep.SUPPORT_OBJECTS, payload);

        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteSupportPagesObject({ commit }, id) {
      commit("setWorking", true);
      try {
        const res = await api.delete(ep.SUPPORT_OBJECT_BY_ID(id));

        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
